import React from 'react';
import './Footer.css';
import Logo from '../../../../assets/AssetHouseLogo.png';

const Footer = () => {
    return (
        <div className="homepage__footer__container">
            <div className="container mx-auto d-flex flex-wrap justify-content-between align-items-center">
                <div className="w-50 d-flex flex-wrap align-items-center">
                    <img src={Logo} alt="footer-logo"/>
                    <h5 className="mx-4"><strong>Asset House</strong></h5>
                    <h6>
                        <small>Copyright by 2022 RedQ, Inc</small>
                    </h6>
                </div>
                <div className="w-50">
                    <ul className="d-flex flex-wrap align-items-center">
                        <li>
                            <a href="/"><strong>Home</strong></a>
                        </li>
                        <li>
                            <a href="/"><strong>Pricing</strong></a>
                        </li>
                        <li>
                            <a href="/"><strong>Features</strong></a>
                        </li>
                        <li>
                            <a href="/"><strong>Contact Us</strong></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Footer
